import { Link } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav aria-label="面包屑导航" className="py-3">
      <ol className="flex items-center flex-wrap gap-1 text-sm">
        {items.map((item, index) => (
          <li key={index} className="flex items-center gap-1">
            {index > 0 && (
              <span className="text-foreground-400 mx-1">
                <i className="ri-arrow-right-s-line text-xs" />
              </span>
            )}
            {item.href ? (
              <Link
                to={item.href}
                className="text-foreground-500 hover:text-primary-600 transition-colors cursor-pointer no-underline whitespace-nowrap"
              >
                {item.label}
              </Link>
            ) : (
              <span className="text-foreground-800 font-medium whitespace-nowrap">
                {item.label}
              </span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}